import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let RouteList = [
  {
    path: "/home",
    component: (resolve) => require(["@/views/layout/App.vue"], resolve),
    meta: {
      title: "首页",
      keepAlive: false,
    },
    children: [
      {
        path: "/home",
        name: "Dashboard",
        meta: {
          title: "首页",
          keepAlive: true,
        },
        component: (resolve) => require(["@/views/home/Index.vue"], resolve),
      },
      {
        path: "/app_adm",
        name: "appAdm",
        meta: {
          title: "应用管理",
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/adm/app_adm.vue"], resolve),
      },

      {
        path: "/task_adm",
        name: "taskAdm",
        meta: {
          title: "任务管理",
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/adm/task_adm.vue"], resolve),
      },
      {
        path: "/theLog",
        name: "theLog",
        meta: {
          title: "日志管理",
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/adm/theLog.vue"], resolve),
      },

      {
        path: "/mpp_adm",
        name: "mppAdm",
        meta: {
          title: "公众号管理",
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/adm/mpp_adm.vue"], resolve),
      },

      {
        path: "/cinema_adm",
        name: "cinemaAdm",
        meta: {
          title: "影院管理",
          keepAlive: false,
        },
        component: (resolve) =>
          require(["@/views/adm/cinema_adm.vue"], resolve),
      },
      {
        path: "/cinemaLine_adm",
        name: "cinemaLineAdm",
        meta: {
          title: "院线管理",
          keepAlive: false,
        },
        component: (resolve) =>
          require(["@/views/adm/cinemaLine_adm.vue"], resolve),
      },
      {
        path: "/capital_statement",
        name: "CapitalStatement",
        meta: {
          title: "账户流水",
          keepAlive: false,
        },
        component: (resolve) =>
          require(["@/views/adm/capital_statement.vue"], resolve),
      },
      {
        path: "/lock_order",
        name: "LockOrder",
        meta: {
          title: "冻结明细",
          keepAlive: false,
        },
        component: (resolve) =>
          require(["@/views/adm/lock_order.vue"], resolve),
      },
      {
        path: '/merchant',
        name: 'merchant',
        meta: {
          title: '收款商户',
          keepAlive: false
        },
        component: resolve => require(['@/views/finance/merchant.vue'], resolve)
      },
      {
        path: '/city',
        name: 'city',
        meta: {
          title: '城市管理',
          keepAlive: false
        },
        component: resolve => require(['@/views/region/city.vue'], resolve)
      },
      {
        path: '/category',
        name: 'category',
        meta: {
          title: '类目管理',
          keepAlive: false
        },
        component: resolve => require(['@/views/goodsClass/category.vue'], resolve)
      },
      {
        path: '/label',
        name: 'label',
        meta: {
          title: '标签管理',
          keepAlive: false
        },
        component: resolve => require(['@/views/goodsClass/label.vue'], resolve)
      },
      {
        path: '/afterSales',
        name: 'afterSales',
        meta: {
          title: '售后分类',
          keepAlive: false
        },
        component: resolve => require(['@/views/goodsClass/afterSales.vue'], resolve)
      },
      {
        path: '/other',
        name: 'other',
        meta: {
          title: '其他分类',
          keepAlive: false
        },
        component: resolve => require(['@/views/goodsClass/other.vue'], resolve)
      },
      {
        path: '/itemAdmin',
        name: 'itemAdmin',
        meta: {
          title: '项目管理',
          keepAlive: false
        },
        component: resolve => require(['@/views/itemAdmin/itemAdmin.vue'], resolve)
      },
      {
        path: '/user',
        name: 'user',
        meta: {
          title: '用户管理',
          keepAlive: false
        },
        component: resolve => require(['@/views/itemAdmin/user.vue'], resolve)
      },
      {
        path: '/dict',
        name: 'dict',
        meta: {
          title: '字典管理',
        },
        component: resolve => require(['@/views/dict/dict.vue'], resolve)
      },
      {
        path: '/synchronous',
        name: 'synchronous',
        meta: {
          title: '联联同步',
        },
        component: resolve => require(['@/views/synchronous/synchronous.vue'], resolve)
      },
      {
        path: '/tencent',
        name: 'tencent',
        meta: {
          title: '腾讯配置',
        },
        component: resolve => require(['@/views/tencent/tencent.vue'], resolve)
      },
      {
        path: '/video',
        name: 'video',
        meta: {
          title: '视频号小店管理',
        },
        component: resolve => require(['@/views/video/video.vue'], resolve)
      },
      {
        path: '/applet',
        name: 'applet',
        meta: {
          title: '微信小程序管理',
        },
        component: resolve => require(['@/views/applet/applet.vue'], resolve)
      },
      {
        path: '/subscription',
        name: 'subscription',
        meta: {
          title: '订阅消息',
        },
        component: resolve => require(['@/views/applet/subscription.vue'], resolve)
      },
      {
        path: '/association',
        name: 'association',
        meta: {
          title: '关联',
        },
        component: resolve => require(['@/views/applet/association.vue'], resolve)
      },
      {
        path: '/ksApplet',
        name: 'ksApplet',
        meta: {
          title: '快手小程序管理',
        },
        component: resolve => require(['@/views/applet/ksApplet.vue'], resolve)
      },
      {
        path: '/application',
        name: 'application',
        meta: {
          title: 'SAAS应用管理',
        },
        component: resolve => require(['@/views/saas/application.vue'], resolve)
      },
      {
        path: '/signed_cinema',
        name: 'signed_cinema',
        meta: {
          title: '签约影院',
        },
        component: resolve => require(['@/views/signed/signed_cinema.vue'], resolve)
      },
      {
        path: '/half_mini_program',
        name: 'half_mini_program',
        meta: {
          title: '半屏小程序',
        },
        component: resolve => require(['@/views/applet/half_mini_program.vue'], resolve)
      },
      {
        path: '/theme',
        name: 'theme',
        meta: {
          title: '主题管理',
        },
        component: resolve => require(['@/views/saas/theme.vue'], resolve)
      },
      {
        path: '/task',
        name: 'task',
        meta: {
          title: '升级任务',
        },
        component: resolve => require(['@/views/saas/task.vue'], resolve)
      },
      {
        path: '/material',
        name: 'material',
        meta: {
          title: '素材库',
        },
        component: resolve => require(['@/views/saas/material.vue'], resolve)
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
      keepAlive: false,
    },
    components: {
      blank: (resolve) => require(["@/views/login/Login.vue"], resolve),
    },
  },
  {
    path: "/*",
    name: "NotFound",
    meta: {
      title: "404",
      keepAlive: true,
    },
    components: {
      blank: (resolve) => require(["@/views/error/404.vue"], resolve),
    },
  },
];

export default new Router({
  routes: RouteList,
});
